import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './style.css'
import './assets/styles/animate.css'
import './assets/styles/bootstrap.css'
import './assets/styles/magnific-popup.css'
import './assets/styles/splitting.css'
import './assets/scss/main.scss'
import './assets/fonts/font-awesome/css/font-awesome.css'
import './assets/fonts/font-awesome/css/line-awesome.css'
// import './assets/scss/layout/_header.scss'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)
